module.exports = {"ms":{"quote_3248aaeb":"Harga:","change_c5a551eb":"Ubah:","buy_b7ba300b":"Belian","sell_df50e460":"Jualan"}}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/ms.json
// module id = 218
// module chunks = 3